import React from "react";
import { connect } from "react-redux";
import {
  setOpenExternalLinkInSameTab,
  setGoHome,
} from "../../action/homeAction";
import { currentWidget } from "../../../action/action";
import { Link } from "react-router-dom";
import { CMSPath } from "../../../config/constant";
import {scrollToTop} from '../../../JS/scrollToTop';

class ExternalLink extends React.Component {
  constructor(props) {
    super(props);
    this.iframeTag = React.createRef();
    console.log(
      "setOpenExternalLinkInSameTab",
      this.props.setOpenExternalLinkInSameTab
    );
    this.props.setOpenExternalLinkInSameTab(false);

    this.targetUrl = this.props.currentWidgets.targetUrl;
  }

  componentDidMount() {
    console.log(this.props.currentWidget,"currentWid")
    console.log(this.props.openExternalLinkInSameTab);

    if (
      `${this.targetUrl}`.startsWith("http://") ||
      `${this.targetUrl}`.startsWith("https://")
    ) {
      console.log("${CMSPath}${targetUrl}", `${CMSPath}${this.targetUrl}`);
      this.targetUrlrenderer = `${this.targetUrl}`;
    } else {
      this.targetUrlrenderer = `${CMSPath}${this.targetUrl}`;
      console.log("${targetUrlrenderer}", `${this.targetUrlrenderer}`);
    }

    this.iframeTag.current.src = this.targetUrlrenderer;

    this.setUserAgent(this.iframeTag.current.contentWindow, {
      "User-Agent":
        "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_10_1) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.95 Safari/537.36",
    });

    scrollToTop();
  }

  componentWillUnmount() {
    this.props.currentWidget({});
    // console.log(this.props.openExternalLinkInSameTab);
 
    this.props.setOpenExternalLinkInSameTab(false);
  }

  setUserAgent(window, userAgent) {
    if (window.navigator.userAgent !== userAgent) {
      const userAgentProp = {
        get: function () {
          return userAgent;
        },
      };
      try {
        Object.defineProperty(window.navigator, "userAgent", userAgentProp);
      } catch (e) {
        window.navigator = Object.create(navigator, {
          userAgent: userAgentProp,
        });
      }
    }
  }

  render() {
    return (
      <>
        <header className="inner-pages w-footer subpages">
          <a onClick = {() => {
            this.props.setOpenExternalLinkInSameTab(false);
            this.props.setGoHome(true);
          }}
            className="button-back"></a>

          <div className="heading align-center">
            <div class="splash-brand">
              <img src={`${CMSPath}${this.props.logo}`} />
            </div>
          </div>
        </header>
        
        <section className="widgets external_url_web padding-0 margin-0 container-bg loc-selector">
          <iframe
            ref={this.iframeTag}
            style={{ width: "100%", height: "100%" }}
          ></iframe>
        </section>
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    currentWidgets: state.store.sideNavBar.currentWidget,
    logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
    openExternalLinkInSameTab: state.store2.openExternalLinkInSameTab,
  };
};

  const mapDispatchToProps = {
    setOpenExternalLinkInSameTab,
    currentWidget,
    setGoHome,
  };

  export default connect(mapStateToProps, mapDispatchToProps)(ExternalLink);
